module.exports = __webpack_public_path__ + "img/20220810085251.46cb7003.png";